// 2026-09-22：同会话共用说明配置，保存即更新顶部；切换账号清空并丢弃旧请求，短暂失败沿用默认说明。
import { ref } from 'vue'
import api from '@/api/functionGuides'
import { FunctionGuide, normalizeFunctionGuide } from '@/utils/functionGuides'
export const functionGuides = ref<FunctionGuide[]>([])
let session = '', revision = 0, loadedAt = 0
let pending: Promise<void> | undefined
export const resetFunctionGuides = (key: string) => {
  if (session === key) return
  session = key; revision++; loadedAt = 0; pending = undefined; functionGuides.value = []
}
export const refreshFunctionGuides = (key: string, force = false): Promise<void> => {
  resetFunctionGuides(key)
  if (!key || (!force && loadedAt && Date.now() - loadedAt < 60000)) return Promise.resolve()
  if (pending) return pending
  const expected = revision
  const task = Promise.resolve().then(async () => {
    try {
      const response = await api.list()
      if (expected === revision && key === session && Array.isArray(response.data)) {
        functionGuides.value = response.data.map(normalizeFunctionGuide)
        loadedAt = Date.now()
      }
    } catch { /* 用途配置加载失败不阻断业务页面，下次切页或返回时重试。 */ }
    finally { if (pending === task) pending = undefined }
  })
  pending = task
  return task
}
export const acceptSavedFunctionGuide = (key: string, item: FunctionGuide) => {
  if (key !== session) return
  revision++; pending = undefined
  const guide = normalizeFunctionGuide(item)
  functionGuides.value = [...functionGuides.value.filter(row => row.path !== guide.path), guide]
  loadedAt = 0
}
